import { routes } from "routes";
import { ICollection } from "services/types";
import { RawCollectionTile } from "./RawCollectionTile";

import BROKEN_ICON from "../icons/BookMarkIcon.svg";

export const CollectionTile = (props: {
  userName: string;
  collection: ICollection;
}): JSX.Element => {
  const { collection } = props;

  return (
    <RawCollectionTile
      link={routes.collection(props.userName, collection.folderId)}
      thumbnail={collection.thumbs || BROKEN_ICON}
      published={collection.published}
      label={collection.folderName}
    />
  );
};
